import { render, staticRenderFns } from "./setting-personalInformation.vue?vue&type=template&id=48d924b4&scoped=true&"
import script from "./setting-personalInformation.vue?vue&type=script&lang=js&"
export * from "./setting-personalInformation.vue?vue&type=script&lang=js&"
import style0 from "./setting-personalInformation.vue?vue&type=style&index=0&id=48d924b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d924b4",
  null
  
)

export default component.exports